import * as React from 'react';
import {authorize} from "@athena-portal/components";
import {RouteComponentProps} from "react-router-dom";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {ClaimSubmissionPanel} from "../../../../../components/claims/ClaimSubmissionPanel";
import {HomeOnlineClaimRequest} from "@falcon/services";
import {getSessionStorage} from "../../../../../CommonFunctions";

interface IPageParams {
    policyNumber: string;
}

interface IState {
    onlineClaimRequest: HomeOnlineClaimRequest;
}

interface IProps extends RouteComponentProps<IPageParams> {
    location: any;
}

@authorize
export class HomeClaimSubmittedPage extends React.Component<IProps, IState> {

    private pluginTemplates = new PluginTemplates();

    constructor(props: IProps) {
        super(props);

        const claimRequest: HomeOnlineClaimRequest = getSessionStorage("homeOnlineClaimRequest");

        this.state = {
            onlineClaimRequest: claimRequest
        }
    }

    public componentDidMount(): void {
        window.scrollTo(0, 0);
    }

    public render(): React.ReactNode {
        const backLinkUrl: string = `/dashboard/annualHome/${this.props.match.params.policyNumber}`;

        return (
            <>
                <FalconHeader/>
                <div className="page-contents text-center">
                    {this.pluginTemplates.renderBackLink("Back", true, backLinkUrl)}
                    <ClaimSubmissionPanel onlineClaimRequest={this.state.onlineClaimRequest} showUrgentClaimSection={false} />
                    {this.pluginTemplates.renderBackLink("Back", false, backLinkUrl)}
                </div>
                <FalconFooter/>
            </>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/home/claims/HomeClaimSubmittedPage.tsx